import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineBedSingleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.8 10V5.2c0-1.4-1.1-2.5-2.5-2.5H6.9c-1.4 0-2.5 1.1-2.5 2.5V10C3 10.4 2 11.7 2 13.3v4.4c0 .5.4.9.9.9h1.5v1.1999c0 .5.4.9001.9.9001s.9-.4001.9-.9001V18.6h11.6v1.1999c0 .5.4.9001.9.9001s.9-.4001.9-.9001V18.6h1.5c.5 0 .9-.4.9-.9v-4.4c.1-1.6-.9-2.8-2.2-3.3Zm-6.6-4.1H11c-1.8 0-3.3 1.5-3.3 3.3v.7H6.3V5.2c0-.3.3-.6.6-.6h10.4c.3 0 .6.3.6.6v4.7h-1.5v-.7c0-1.8-1.4-3.3-3.2-3.3ZM9.6 9.2c0-.8.6-1.4 1.4-1.4h2.2c.8 0 1.4.6 1.4 1.4v.7h-5v-.7Zm10.7 4.1v3.4H3.9v-3.4c0-.9.7-1.6 1.6-1.6h13.3c.8 0 1.5.7 1.5 1.6Z"/>
  </SvgIcon>
}

export default LineBedSingleIcon
